import React from "react";
import { Link } from "react-router-dom";
import {
    FaCalendarAlt,
    FaUser,
    FaClock,
    FaChevronLeft,
    FaLinkedin,
    FaTwitter,
    FaFacebook,
    FaShieldAlt,
    FaUsers,
    FaExclamationCircle,
    FaCheckCircle,
    FaMoneyBillWave,
    FaFileContract,
    FaGavel,
    FaHeartbeat,
    FaChild,
    FaUserMd,
} from "react-icons/fa";
import Footer from "../components/Footer";
import Header from "../components/Header";

const DetailBlog14 = () => {
    const blogPost = {
        id: 14,
        title:
            "Assurance Maladie Obligatoire (AMO) au Bénin : Ce que le décret 2025-672 change pour votre entreprise et vos salariés",
        excerpt:
            "Le Bénin poursuit la consolidation de son système de protection sociale. Le décret N° 2025-672 du 29 octobre 2025 renforce le cadre légal, clarifie les responsabilités des employeurs et introduit un régime de sanctions visant à garantir la conformité.",
        date: "29 Octobre 2025",
        author: "Expert CINEF",
        authorTitle: "Expert en Conformité Sociale et Fiscale",
        readTime: "12 min",
        categories: ["Protection Sociale", "Droit Social", "Conformité"],
        tags: [
            "AMO",
            "Assurance Maladie",
            "Bénin",
            "Décret 2025-672",
            "Protection Sociale",
            "Employeurs",
            "Conformité",
        ],
    };

    return (
        <>
            <Header />
            <div className="blog-detail-page">
                {/* Breadcrumb */}
                <nav className="breadcrumb-nav">
                    <div className="container">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Accueil</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/actualites/blog">Blog</Link>
                            </li>
                            <li className="breadcrumb-item active">AMO Bénin</li>
                        </ol>
                    </div>
                </nav>

                <div className="container blog-container">
                    <div className="row">
                        <div className="col-lg-8">
                            <article className="blog-article">
                                <div className="article-header">
                                    <div className="categories-row">
                                        {blogPost.categories.map((cat, idx) => (
                                            <span key={idx} className="cat-badge">{cat}</span>
                                        ))}
                                    </div>
                                    <h1 className="article-title">{blogPost.title}</h1>
                                    <div className="article-meta">
                                        <div className="meta-group">
                                            <FaCalendarAlt className="icon" />
                                            <span>{blogPost.date}</span>
                                        </div>
                                        <div className="meta-group">
                                            <FaUser className="icon" />
                                            <span>{blogPost.author}</span>
                                        </div>
                                        <div className="meta-group">
                                            <FaClock className="icon" />
                                            <span>{blogPost.readTime}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="article-excerpt">
                                    <p>{blogPost.excerpt}</p>
                                </div>

                                <div className="article-content">
                                    {/* Introduction */}
                                    <section className="intro-section">
                                        <div className="intro-card">
                                            <div className="intro-icon">
                                                <FaShieldAlt />
                                            </div>
                                            <p className="intro-text">
                                                Le Bénin poursuit la consolidation de son système de protection sociale. Le <strong>Décret N° 2025-672 du 29 octobre 2025</strong>, qui abroge les dispositions antérieures, notamment celles du décret n° 2023-327 du 21 juin 2023, est entré en vigueur pour définir de manière précise les modalités de mise en œuvre de l'assurance maladie obligatoire.
                                            </p>
                                            <p className="intro-text">
                                                Ce nouveau texte renforce le cadre légal, clarifie les responsabilités des employeurs et des souscripteurs, et introduit un régime de sanctions visant à garantir la conformité.
                                            </p>
                                            <p className="intro-emphasis">
                                                En tant qu'experts en conformité sociale et fiscale, nous vous détaillons les dispositions les plus importantes à connaître.
                                            </p>
                                        </div>
                                    </section>

                                    {/* Section 1: Obligations d'Affiliation */}
                                    <section className="content-section">
                                        <div className="section-header">
                                            <div className="section-number">01</div>
                                            <div className="section-title-group">
                                                <h2 className="section-title">Obligations d'affiliation et de financement : la règle du 80/20</h2>
                                                <div className="title-underline"></div>
                                            </div>
                                        </div>

                                        <p className="section-intro">
                                            Le Décret 2025-672 confirme et précise les obligations de souscription pour les entités du secteur formel :
                                        </p>

                                        <div className="subsection">
                                            <h3 className="subsection-title">
                                                <FaFileContract className="subsection-icon" />
                                                A. Souscription obligatoire
                                            </h3>
                                            <div className="info-boxes">
                                                <div className="info-box primary">
                                                    <div className="box-header">
                                                        <h4>Employeurs du secteur privé</h4>
                                                    </div>
                                                    <p>Les employeurs du secteur privé et les organismes publics à caractère commercial sont tenus de souscrire obligatoirement une police d'assurance maladie couvrant au minimum le panier de soins de base pour leurs salariés, ainsi que pour leurs conjoints et leurs enfants à charge.</p>
                                                </div>
                                                <div className="info-box secondary">
                                                    <div className="box-header">
                                                        <h4>Professions Libérales & Indépendants</h4>
                                                    </div>
                                                    <p>Les membres des professions libérales et les personnes exerçant pour leur propre compte (indépendants) doivent également souscrire une police d'assurance maladie pour eux-mêmes, leurs conjoints et leurs enfants à charge.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="subsection">
                                            <h3 className="subsection-title">
                                                <FaMoneyBillWave className="subsection-icon" />
                                                B. Primes et retenue à la source
                                            </h3>
                                            <div className="highlight-card">
                                                <div className="highlight-icon">
                                                    <FaExclamationCircle />
                                                </div>
                                                <div className="highlight-content">
                                                    <h4>Règle de financement stricte</h4>
                                                    <p>Les souscripteurs publics ou privés (les employeurs) doivent assurer le paiement de la prime d'assurance pour le panier de soins de base à hauteur de <strong>quatre-vingt pour cent (80%) au moins</strong>.</p>
                                                    <p>Le solde à la charge des salariés fait l'objet d'une retenue à la source par l'employeur, qui assure ensuite le paiement global de la prime. Cela positionne l'employeur comme le collecteur principal et garant de l'acquittement de la prime auprès de l'assureur (l'Agence nationale de Protection sociale ou toute autre structure agréée).</p>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    {/* Section 2: Bénéficiaires */}
                                    <section className="content-section">
                                        <div className="section-header">
                                            <div className="section-number">02</div>
                                            <div className="section-title-group">
                                                <h2 className="section-title">Clarification des bénéficiaires et des ayants droit</h2>
                                                <div className="title-underline"></div>
                                            </div>
                                        </div>

                                        <p className="section-intro">
                                            Le décret de 2025 apporte des précisions cruciales concernant la couverture des familles :
                                        </p>

                                        <div className="subsection">
                                            <h3 className="subsection-title">
                                                <FaUsers className="subsection-icon" />
                                                A. Définition des ayants droit
                                            </h3>
                                            <div className="definition-card">
                                                <p className="definition-intro">Est considéré comme ayant droit :</p>
                                                <ul className="definition-list">
                                                    <li>Le conjoint(e) de l'assuré qui ne dispose pas de titre personnel d'une assurance maladie</li>
                                                    <li>Les enfant(s) à charge tels que définis par le code de Sécurité sociale</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div className="subsection">
                                            <h3 className="subsection-title">
                                                <FaChild className="subsection-icon" />
                                                B. Cas des enfants à charge
                                            </h3>
                                            <div className="children-coverage">
                                                <div className="coverage-rule">
                                                    <div className="rule-badge">Limite Standard</div>
                                                    <p>Le nombre d'enfants obligatoirement pris en charge par les souscripteurs est limité à <strong>quatre (4)</strong>. Sont concernés les enfants âgés de moins de <strong>vingt-et-un (21) ans</strong> et sans emploi.</p>
                                                </div>

                                                <div className="exception-box">
                                                    <div className="exception-header">
                                                        <FaHeartbeat className="exception-icon" />
                                                        <h4>Exception importante</h4>
                                                    </div>
                                                    <p>Le décret introduit une disposition essentielle pour la protection sociale : <strong>les enfants porteurs d'une infirmité ou d'une maladie incurable et qui sont dans l'impossibilité de se livrer à un travail salarié sont pris en charge sans limitation d'âge</strong>.</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="subsection">
                                            <h3 className="subsection-title">
                                                <FaShieldAlt className="subsection-icon" />
                                                C. Élargissement de la couverture sociale
                                            </h3>
                                            <div className="coverage-expansion">
                                                <div className="expansion-item">
                                                    <div className="expansion-icon state">
                                                        <FaCheckCircle />
                                                    </div>
                                                    <div className="expansion-content">
                                                        <h4>Prise en charge par l'état</h4>
                                                        <p>L'État maintient sa prise en charge intégrale de la prime pour les pauvres extrêmes et la moitié de la prime pour les pauvres non extrêmes.</p>
                                                    </div>
                                                </div>
                                                <div className="expansion-item">
                                                    <div className="expansion-icon vulnerable">
                                                        <FaUsers />
                                                    </div>
                                                    <div className="expansion-content">
                                                        <h4>Populations vulnérables</h4>
                                                        <p>Le décret élargit également explicitement la liste des bénéficiaires pris en charge par l'État pour leur police d'assurance de base, en incluant notamment : les enfants, les personnes en situation de mendicité et les malades mentaux référés par les structures de l'État.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    {/* Section 3: Panier de Soins */}
                                    <section className="content-section">
                                        <div className="section-header">
                                            <div className="section-number">03</div>
                                            <div className="section-title-group">
                                                <h2 className="section-title">Le panier de soins de base et le reste à charge</h2>
                                                <div className="title-underline"></div>
                                            </div>
                                        </div>

                                        <div className="subsection">
                                            <h3 className="subsection-title">
                                                <FaUserMd className="subsection-icon" />
                                                A. Contenu du panier de soins
                                            </h3>
                                            <p className="subsection-intro">Le panier de soins de base obligatoire couvre une liste d'affections spécifiques (traumatismes, infections courantes, paludisme, etc.). Il inclut des prestations comme :</p>

                                            <div className="services-grid">
                                                <div className="service-card">
                                                    <div className="service-icon consultation">
                                                        <FaUserMd />
                                                    </div>
                                                    <h4>Consultations</h4>
                                                    <ul>
                                                        <li>Les consultations de médecine générale</li>
                                                        <li>Les consultations de médecin spécialiste pour les affections incluses</li>
                                                    </ul>
                                                </div>

                                                <div className="service-card">
                                                    <div className="service-icon maternity">
                                                        <FaHeartbeat />
                                                    </div>
                                                    <h4>Suivi Grossesse</h4>
                                                    <ul>
                                                        <li>Le suivi de la grossesse, incluant toutes les consultations prénatales</li>
                                                        <li>La prise en charge de la grossesse extra utérine</li>
                                                        <li>Les accouchements par voie basse et par césarienne</li>
                                                    </ul>
                                                </div>

                                                <div className="service-card">
                                                    <div className="service-icon hospital">
                                                        <FaShieldAlt />
                                                    </div>
                                                    <h4>Hospitalisations</h4>
                                                    <ul>
                                                        <li>Les hospitalisations</li>
                                                        <li>Les examens de laboratoire et d'imagerie médicale en urgence pour les pathologies prises en charge</li>
                                                    </ul>
                                                </div>

                                                <div className="service-card">
                                                    <div className="service-icon surgery">
                                                        <FaGavel />
                                                    </div>
                                                    <h4>Chirurgies & Urgences</h4>
                                                    <ul>
                                                        <li>Diverses chirurgies (appendicectomie, cure de hernie, césarienne)</li>
                                                        <li>Soins d'urgence et réanimation</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="subsection">
                                            <h3 className="subsection-title">
                                                <FaMoneyBillWave className="subsection-icon" />
                                                B. Le Ticket Modérateur
                                            </h3>
                                            <div className="ticket-moderateur">
                                                <div className="ticket-main">
                                                    <div className="ticket-percentage">20%</div>
                                                    <div className="ticket-text">
                                                        <p>Un ticket modérateur de <strong>vingt pour cent (20%)</strong> est payé par les bénéficiaires de soins.</p>
                                                    </div>
                                                </div>
                                                <div className="ticket-exception">
                                                    <FaCheckCircle className="ticket-exception-icon" />
                                                    <p>Cependant, cette participation financière <strong>n'est pas due pour les pauvres extrêmes</strong>.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    {/* Section 4: Sanctions */}
                                    <section className="content-section sanctions-section">
                                        <div className="section-header">
                                            <div className="section-number warning">04</div>
                                            <div className="section-title-group">
                                                <h2 className="section-title">Attention : Le Régime de Sanctions est Formalisé</h2>
                                                <div className="title-underline warning"></div>
                                            </div>
                                        </div>

                                        <div className="alert-box danger">
                                            <FaExclamationCircle className="alert-icon" />
                                            <p>Le Décret 2025-672 consacre un chapitre entier aux <strong>Sanctions</strong>, signalant la volonté des autorités de garantir l'application du dispositif.</p>
                                        </div>

                                        <div className="sanctions-grid">
                                            <div className="sanction-card employer">
                                                <div className="sanction-header">
                                                    <FaGavel className="sanction-icon" />
                                                    <h3>Sanctions pour les Employeurs (Non-Affiliation)</h3>
                                                </div>
                                                <div className="sanction-body">
                                                    <p>Tout employeur (sauf l'État) qui ne procède pas à l'affiliation ou au paiement d'au moins 80% de la prime d'assurance d'un salarié à un régime d'assurance maladie est passible d'une amende de :</p>
                                                    <div className="amount-display">
                                                        <span className="amount-number_one">200 000</span>
                                                        <span className="amount-currency">FCFA</span>
                                                        <span className="per-unit">par employé</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="sanction-card fraud">
                                                <div className="sanction-header">
                                                    <FaExclamationCircle className="sanction-icon" />
                                                    <h3>Sanctions Pénales (Fraude)</h3>
                                                </div>
                                                <div className="sanction-body">
                                                    <p>Toute personne qui bénéficie ou tente de bénéficier de prestations d'assurance maladie par des moyens frauduleux est passible de :</p>
                                                    <div className="amount-display">
                                                        <span className="amount-number">200 000</span>
                                                        <span className="amount-currency">FCFA</span>
                                                    </div>
                                                    <p className="additional-penalty">+ remboursement des sommes indûment payées par l'assureur</p>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    {/* Conclusion */}
                                    <section className="conclusion-section">
                                        <div className="conclusion-header">
                                            <FaCheckCircle className="conclusion-icon" />
                                            <h2>Conclusion et Recommandation</h2>
                                        </div>

                                        <div className="conclusion-content">
                                            <p>Le Décret 2025-672 renforce la sécurité sociale et la prise en charge des populations vulnérables, tout en responsabilisant fortement les employeurs et les souscripteurs individuels.</p>

                                            <div className="key-takeaway">
                                                <h3>Pour votre entreprise</h3>
                                                <p>La mise en conformité immédiate avec les obligations d'affiliation, de retenue à la source et de paiement des primes est essentielle afin d'éviter les sanctions pécuniaires (200 000 F CFA par salarié non affilié).</p>
                                            </div>

                                            <div className="recommendation-box">
                                                <div className="recommendation-icon">
                                                    <FaShieldAlt />
                                                </div>
                                                <div className="recommendation-text">
                                                    <h4>Recommandation</h4>
                                                    <p>Nous vous invitons à vérifier sans délai la conformité de vos procédures internes (paie, déclarations sociales) avec les exigences de ce nouveau décret. <strong>CINEF-EXPERTISE COMPTABLE</strong> est à votre disposition pour vous accompagner dans l'audit de votre situation et la mise en place des mécanismes de prélèvement et d'affiliation requis.</p>
                                                </div>
                                            </div>

                                            <div className="cta-box">
                                                <h3>Assurez la conformité de votre entreprise</h3>
                                                <p>Contactez nos experts pour un diagnostic complet de votre situation AMO</p>
                                                <button
                                                    className="cta-button"
                                                    onClick={() => window.open('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ30HiUAglAWfWtbsla-NeJVC3PrBwr9y2_8BzlRazyhV4YI0qYb89EJJ8l2yuCAzfRQ6-0hqkcK?gv=true', '_blank')}
                                                >
                                                    Prendre rendez-vous
                                                </button>
                                            </div>
                                        </div>
                                    </section>

                                    {/* Resources */}
                                    <section className="resources-section">
                                        <h3>Pour lire l'intégralité de la loi et aller plus loin</h3>
                                        <div className="resources-list-content">
                                            <a href="#" target="_blank" rel="noopener noreferrer" className="resource-link">
                                                <FaFileContract />
                                                <span>Décret N° 2025-672 du 29 octobre 2025</span>
                                            </a>
                                            <a href="https://sgg.gouv.bj/" target="_blank" rel="noopener noreferrer" className="resource-link">
                                                <FaShieldAlt />
                                                <span>https://sgg.gouv.bj/</span>
                                            </a>
                                        </div>

                                        <div className="hashtags">
                                            {["#CINEF", "#LoiBénin", "#Réglementation", "#OECCA-BENIN", "#Conformité", "#DroitSocial", "#Fiscalité", "#ExpertComptable", "#CINEFExpertise", "#EntrepriseBenin", "#PMEBenin", "#Employeurs", "#Management", "#SecteurPrivé"].map((tag, idx) => (
                                                <span key={idx} className="hashtag">{tag}</span>
                                            ))}
                                        </div>
                                    </section>
                                </div>

                                <div className="article-footer">
                                    <div className="tags-section">
                                        <h5>Tags</h5>
                                        <div className="tags-list">
                                            {blogPost.tags.map((tag, idx) => (
                                                <span key={idx} className="tag-item">#{tag}</span>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="share-section">
                                        <h5>Partager cet article</h5>
                                        <div className="social-share">
                                            <a href="https://www.linkedin.com/company/cinef-ec" target="_blank" className="share-btn linkedin"><FaLinkedin /></a>
                                            <a href="#" className="share-btn twitter"><FaTwitter /></a>
                                            <a href="#" className="share-btn facebook"><FaFacebook /></a>
                                        </div>
                                    </div>
                                </div>

                                <div className="navigation-section">
                                    <Link to="/actualites/blog" className="back-btn">
                                        <FaChevronLeft /> Retour au blog
                                    </Link>
                                </div>
                            </article>
                        </div>

                        <div className="col-lg-4">
                            <aside className="blog-sidebar">
                                <div className="sidebar-card author-card">
                                    <h4 className="card-title">À propos de l'auteur</h4>
                                    <div className="author-info">
                                        <div className="author-avatar">
                                            <FaUser />
                                        </div>
                                        <h5>{blogPost.author}</h5>
                                        <p className="author-role">{blogPost.authorTitle}</p>
                                        <p className="author-bio">
                                            Expert en conformité sociale et fiscale, spécialisé dans l'accompagnement des entreprises dans leur mise en conformité réglementaire.
                                        </p>
                                    </div>
                                </div>

                                {/* <div className="sidebar-card newsletter-card">
                                    <h4 className="card-title">Newsletter</h4>
                                    <p>Recevez nos actualités réglementaires</p>
                                    <form className="newsletter-form">
                                        <input type="email" placeholder="Votre email" required />
                                        <button type="submit">S'inscrire</button>
                                    </form>
                                </div> */}

                                <div className="sidebar-card resources-card">
                                    <h4 className="card-title">Ressources utiles</h4>
                                    <ul className="resources-list">
                                        <li>
                                            <a href="https://sgg.gouv.bj/" target="_blank" rel="noopener noreferrer">
                                                Secrétariat Général du Gouvernement
                                                <span>→</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://oeccabenin.bj/" target="_blank" rel="noopener noreferrer">
                                                Ordre des Experts-Comptables
                                                <span>→</span>
                                            </a>
                                        </li>
                                        <li>
                                            <Link to="/services">
                                                Nos services
                                                <span>→</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </aside>
                        </div>
                    </div>
                </div>

                <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .blog-detail-page {
          min-height: 100vh;
          padding: 2rem 0;
        }

        /* Breadcrumb */
        .breadcrumb-nav {
          background: white;
          padding: 1rem 0;
          margin-bottom: 2rem;
          border-bottom: 1px solid #e2e8f0;
          margin-top: 80px;
        }

        .breadcrumb {
          display: flex;
          list-style: none;
          padding: 0;
          margin: 0;
          font-size: 0.875rem;
        }

        .breadcrumb-item {
          color: #64748b;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          content: "›";
          margin: 0 0.75rem;
          color: #94a3b8;
          font-size: 1.2rem;
        }

        .breadcrumb-item a {
          color: #475569;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s;
        }

        .breadcrumb-item a:hover {
          color: #dc2626;
        }

        .breadcrumb-item.active {
          color: #1e293b;
          font-weight: 600;
        }

        .blog-container {
          max-width: 1400px;
        }

        .blog-article {
          background: white;
          border-radius: 20px;
          padding: 3rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
        }

        .article-header {
          margin-bottom: 2.5rem;
          padding-bottom: 2rem;
          border-bottom: 2px solid #f1f5f9;
        }

        .categories-row {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 1.5rem;
        }

        .cat-badge {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          padding: 0.5rem 1rem;
          border-radius: 50px;
          color: white;
          font-weight: 600;
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .article-title {
          font-size: 2.5rem;
          font-weight: 800;
          line-height: 1.2;
          color: #1e293b;
          margin-bottom: 1.5rem;
        }

        .article-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 2rem;
        }

        .meta-group {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #64748b;
          font-size: 0.9rem;
        }

        .meta-group .icon {
          color: #dc2626;
          font-size: 1rem;
        }

        .article-excerpt {
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          padding: 1.5rem;
          border-radius: 12px;
          border-left: 4px solid #dc2626;
          margin-bottom: 3rem;
        }

        .article-excerpt p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #334155;
          font-weight: 500;
        }

        /* Introduction Section */
        .intro-section {
          margin-bottom: 3rem;
        }

        .intro-card {
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          padding: 2.5rem;
          border-radius: 16px;
          color: white;
          box-shadow: 0 20px 60px rgba(30, 41, 59, 0.3);
        }

        .intro-icon {
          font-size: 3rem;
          margin-bottom: 1.5rem;
          color: #22c55e;
        }

        .intro-text {
          font-size: 1.05rem;
          line-height: 1.8;
          margin-bottom: 1rem;
          color: #e2e8f0;
        }

        .intro-text strong {
          color: #fbbf24;
          font-weight: 700;
        }

        .intro-emphasis {
          font-size: 1.1rem;
          font-weight: 600;
          color: #22c55e;
          margin-top: 1.5rem;
          padding-top: 1.5rem;
          border-top: 1px solid rgba(255, 255, 255, 0.2);
        }

        /* Content Sections */
        .content-section {
          margin-bottom: 4rem;
        }

        .section-header {
          display: flex;
          align-items: flex-start;
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .section-number {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          font-size: 1.5rem;
          font-weight: 800;
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .section-number.warning {
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
        }

        .section-title-group {
          flex: 1;
        }

        .section-title {
          font-size: 2rem;
          font-weight: 800;
          color: #1e293b;
          margin-bottom: 0.5rem;
        }

        .title-underline {
          width: 100px;
          height: 4px;
          background: linear-gradient(90deg, #dc2626 0%, #16a34a 100%);
          border-radius: 2px;
        }

        .title-underline.warning {
          background: linear-gradient(90deg, #dc2626 0%, #b91c1c 100%);
        }

        .section-intro {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #475569;
          margin-bottom: 2rem;
        }

        /* Subsections */
        .subsection {
          margin-bottom: 2.5rem;
        }

        .subsection-title {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          font-size: 1.4rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1.5rem;
        }

        .subsection-icon {
          color: #dc2626;
          font-size: 1.5rem;
        }

        /* Info Boxes */
        .info-boxes {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 1.5rem;
          margin-top: 1.5rem;
        }

        .info-box {
          padding: 2rem;
          border-radius: 12px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }

        .info-box.primary {
          background: linear-gradient(135deg, #fef2f2 0%, #fff 100%);
          border: 2px solid #fecaca;
        }

        .info-box.secondary {
          background: linear-gradient(135deg, #f0fdf4 0%, #fff 100%);
          border: 2px solid #bbf7d0;
        }

        .box-header h4 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .info-box p {
          font-size: 1rem;
          line-height: 1.7;
          color: #475569;
        }

        /* Highlight Card */
        .highlight-card {
          display: flex;
          gap: 1.5rem;
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          padding: 2rem;
          border-radius: 12px;
          border-left: 4px solid #dc2626;
          margin-top: 1.5rem;
        }

        .highlight-icon {
          font-size: 2.5rem;
          color: #dc2626;
          flex-shrink: 0;
        }

        .highlight-content h4 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .highlight-content p {
          font-size: 1rem;
          line-height: 1.7;
          color: #475569;
          margin-bottom: 1rem;
        }

        .highlight-content strong {
          color: #dc2626;
          font-weight: 700;
        }

        /* Definition Card */
        .definition-card {
          background: #f8fafc;
          padding: 2rem;
          border-radius: 12px;
          border: 2px solid #e2e8f0;
          margin-top: 1rem;
        }

        .definition-intro {
          font-size: 1.1rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .definition-list {
          list-style: none;
          padding-left: 0;
        }

        .definition-list li {
          padding: 0.75rem 0;
          padding-left: 2rem;
          position: relative;
          font-size: 1rem;
          line-height: 1.7;
          color: #475569;
        }

        .definition-list li::before {
          content: "✓";
          position: absolute;
          left: 0;
          color: #16a34a;
          font-weight: 700;
          font-size: 1.2rem;
        }

        /* Children Coverage */
        .children-coverage {
          margin-top: 1.5rem;
        }

        .coverage-rule {
          background: #f8fafc;
          padding: 2rem;
          border-radius: 12px;
          margin-bottom: 1.5rem;
        }

        .rule-badge {
          display: inline-block;
          background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }

        .coverage-rule p {
          font-size: 1.05rem;
          line-height: 1.7;
          color: #475569;
        }

        .coverage-rule strong {
          color: #1e293b;
          font-weight: 700;
        }

        .exception-box {
          background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
          padding: 2rem;
          border-radius: 12px;
          border: 2px solid #86efac;
        }

        .exception-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1rem;
        }

        .exception-icon {
          font-size: 2rem;
          color: #16a34a;
        }

        .exception-header h4 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1e293b;
        }

        .exception-box p {
          font-size: 1.05rem;
          line-height: 1.7;
          color: #475569;
        }

        .exception-box strong {
          color: #16a34a;
          font-weight: 700;
        }

        /* Coverage Expansion */
        .coverage-expansion {
          display: grid;
          gap: 1.5rem;
          margin-top: 1.5rem;
        }

        .expansion-item {
          display: flex;
          gap: 1.5rem;
          background: white;
          padding: 2rem;
          border-radius: 12px;
          border: 2px solid #e2e8f0;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
        }

        .expansion-icon {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.8rem;
          flex-shrink: 0;
        }

        .expansion-icon.state {
          background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
          color: #1e40af;
        }

        .expansion-icon.vulnerable {
          background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
          color: #b45309;
        }

        .expansion-content h4 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 0.75rem;
        }

        .expansion-content p {
          font-size: 1rem;
          line-height: 1.7;
          color: #475569;
        }

        /* Services Grid */
        .services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          margin-top: 1.5rem;
        }

        .service-card {
          background: white;
          padding: 2rem;
          border-radius: 12px;
          border: 2px solid #e2e8f0;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
          transition: transform 0.3s, box-shadow 0.3s;
        }

        .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .service-icon {
          width: 60px;
          height: 60px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.8rem;
          margin-bottom: 1rem;
        }

        .service-icon.consultation {
          background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
          color: #1e40af;
        }

        .service-icon.maternity {
          background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
          color: #be185d;
        }

        .service-icon.hospital {
          background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
          color: #15803d;
        }

        .service-icon.surgery {
          background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
          color: #b45309;
        }

        .service-card h4 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .service-card ul {
          list-style: none;
          padding-left: 0;
        }

        .service-card ul li {
          padding: 0.5rem 0;
          padding-left: 1.5rem;
          position: relative;
          font-size: 0.95rem;
          line-height: 1.6;
          color: #475569;
        }

        .service-card ul li::before {
          content: "•";
          position: absolute;
          left: 0;
          color: #dc2626;
          font-weight: 700;
          font-size: 1.2rem;
        }

        /* Ticket Modérateur */
        .ticket-moderateur {
          margin-top: 1.5rem;
        }

        .ticket-main {
          display: flex;
          align-items: center;
          gap: 2rem;
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          padding: 2rem;
          border-radius: 12px;
          margin-bottom: 1.5rem;
        }

        .ticket-percentage {
          font-size: 4rem;
          font-weight: 900;
          color: #dc2626;
          line-height: 1;
        }

        .ticket-text p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #475569;
        }

        .ticket-text strong {
          color: #dc2626;
          font-weight: 700;
        }

        .ticket-exception {
          display: flex;
          align-items: center;
          gap: 1rem;
          background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);
          padding: 1.5rem;
          border-radius: 12px;
        }

        .ticket-exception-icon {
          font-size: 2rem;
          color: #16a34a;
          flex-shrink: 0;
        }

        .ticket-exception p {
          font-size: 1.05rem;
          line-height: 1.7;
          color: #475569;
        }

        .ticket-exception strong {
          color: #16a34a;
          font-weight: 700;
        }

        /* Sanctions Section */
        .sanctions-section {
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          padding: 3rem;
          border-radius: 16px;
          border: 2px solid #fecaca;
        }

        .alert-box {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1.5rem;
          border-radius: 12px;
          margin-bottom: 2rem;
        }

        .alert-box.danger {
          background: white;
          border: 2px solid #dc2626;
        }

        .alert-icon {
          font-size: 2rem;
          color: #dc2626;
          flex-shrink: 0;
        }

        .alert-box p {
          font-size: 1.1rem;
          line-height: 1.7;
          color: #1e293b;
        }

        .alert-box strong {
          color: #dc2626;
          font-weight: 700;
        }

        .sanctions-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 2rem;
        }

        .sanction-card {
          background: white;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .sanction-header {
          padding: 2rem;
          display: flex;
          align-items: center;
          gap: 1rem;
        }

        .sanction-card.employer .sanction-header {
          background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
        }

        .sanction-card.fraud .sanction-header {
          background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
        }

        .sanction-icon {
          font-size: 2rem;
          color: white;
        }

        .sanction-header h3 {
          font-size: 1.3rem;
          font-weight: 700;
          color: white;
        }

        .sanction-body {
          padding: 2rem;
        }

        .sanction-body p {
          font-size: 1rem;
          line-height: 1.7;
          color: #475569;
          margin-bottom: 1.5rem;
        }

        .amount-display {
          display: flex;
          align-items: baseline;
          gap: 0.5rem;
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          padding: 1.5rem;
          border-radius: 12px;
          margin: 1.5rem 0;
          justify-content: center;
        }

        .amount-number_one{
          font-size: 2rem;
          font-weight: 900;
          color: #dc2626;
        }

        .amount-number {
          font-size: 2rem;
          font-weight: 900;
          color: #dc2626;
        }

        .amount-currency {
          font-size: 1.5rem;
          font-weight: 700;
          color: #dc2626;
        }

        .per-unit {
          font-size: 1rem;
          color: #475569;
          font-weight: 600;
        }

        .additional-penalty {
          font-size: 1rem;
          color: #dc2626;
          font-weight: 600;
          text-align: center;
        }

        /* Conclusion Section */
        .conclusion-section {
          background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
          padding: 3rem;
          border-radius: 16px;
          margin-bottom: 3rem;
        }

        .conclusion-header {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .conclusion-icon {
          font-size: 2.5rem;
          color: #16a34a;
        }

        .conclusion-header h2 {
          font-size: 2rem;
          font-weight: 800;
          color: #1e293b;
        }

        .conclusion-content > p {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #475569;
          margin-bottom: 2rem;
        }

        .key-takeaway {
          background: white;
          padding: 2rem;
          border-radius: 12px;
          border-left: 4px solid #16a34a;
          margin-bottom: 2rem;
        }

        .key-takeaway h3 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .key-takeaway p {
          font-size: 1.05rem;
          line-height: 1.7;
          color: #475569;
        }

        .recommendation-box {
          display: flex;
          gap: 1.5rem;
          background: white;
          padding: 2rem;
          border-radius: 12px;
          margin-bottom: 2rem;
        }

        .recommendation-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          color: white;
          flex-shrink: 0;
        }

        .recommendation-text h4 {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .recommendation-text p {
          font-size: 1.05rem;
          line-height: 1.7;
          color: #475569;
        }

        .recommendation-text strong {
          color: #dc2626;
          font-weight: 700;
        }

        .cta-box {
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          padding: 3rem;
          border-radius: 12px;
          text-align: center;
          color: white;
        }

        .cta-box h3 {
          font-size: 1.8rem;
          font-weight: 800;
          margin-bottom: 1rem;
        }

        .cta-box p {
          font-size: 1.1rem;
          margin-bottom: 2rem;
          color: #e2e8f0;
        }

        .cta-button {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          padding: 1rem 3rem;
          border: none;
          border-radius: 50px;
          font-size: 1.1rem;
          font-weight: 700;
          cursor: pointer;
          transition: transform 0.3s, box-shadow 0.3s;
        }

        .cta-button:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 30px rgba(220, 38, 38, 0.3);
        }

        /* Resources Section */
        .resources-section {
          background: #f8fafc;
          padding: 2.5rem;
          border-radius: 12px;
          margin-bottom: 3rem;
        }

        .resources-section h3 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1.5rem;
        }

        .resources-list-content {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .resource-link {
          display: flex;
          align-items: center;
          gap: 1rem;
          padding: 1rem;
          background: white;
          border-radius: 8px;
          text-decoration: none;
          color: #475569;
          transition: all 0.3s;
          border: 1px solid #e2e8f0;
        }

        .resource-link:hover {
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          border-color: #dc2626;
          transform: translateX(5px);
        }

        .resource-link svg {
          color: #dc2626;
          font-size: 1.3rem;
        }

        .hashtags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          padding-top: 1.5rem;
          border-top: 1px solid #e2e8f0;
        }

        .hashtag {
          background: white;
          color: #64748b;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.85rem;
          font-weight: 600;
          border: 1px solid #e2e8f0;
          transition: all 0.3s;
        }

        .hashtag:hover {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          border-color: transparent;
        }

        /* Article Footer */
        .article-footer {
          margin-top: 3rem;
          padding-top: 3rem;
          border-top: 2px solid #e2e8f0;
        }

        .tags-section {
          margin-bottom: 2rem;
        }

        .tags-section h5 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .tags-list {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
        }

        .tag-item {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          color: #475569;
          padding: 0.5rem 1rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 600;
          border: 1px solid #e2e8f0;
          transition: all 0.3s;
        }

        .tag-item:hover {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          border-color: transparent;
          transform: translateY(-2px);
        }

        .share-section h5 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .social-share {
          display: flex;
          gap: 1rem;
        }

        .share-btn {
          width: 50px;
          height: 50px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          color: white;
          text-decoration: none;
          transition: transform 0.3s, box-shadow 0.3s;
        }

        .share-btn.linkedin {
          background: linear-gradient(135deg, #0077b5 0%, #005582 100%);
        }

        .share-btn.twitter {
          background: linear-gradient(135deg, #1da1f2 0%, #0c85d0 100%);
        }

        .share-btn.facebook {
          background: linear-gradient(135deg, #1877f2 0%, #0c63d4 100%);
        }

        .share-btn:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        /* Navigation Section */
        .navigation-section {
          margin-top: 3rem;
        }

        .back-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          padding: 1rem 2rem;
          background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
          color: white;
          text-decoration: none;
          border-radius: 50px;
          font-weight: 600;
          transition: transform 0.3s, box-shadow 0.3s;
        }

        .back-btn:hover {
          transform: translateX(-5px);
          box-shadow: 0 10px 30px rgba(30, 41, 59, 0.3);
        }

        /* Sidebar */
        .blog-sidebar {
          position: sticky;
          top: 100px;
        }

        .sidebar-card {
          background: white;
          border-radius: 16px;
          padding: 2rem;
          margin-bottom: 2rem;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
        }

        .card-title {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 2px solid #f1f5f9;
        }

        /* Author Card */
        .author-info {
          text-align: center;
        }

        .author-avatar {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          color: white;
          margin: 0 auto 1rem;
        }

        .author-info h5 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 0.5rem;
        }
        .author-role {
          font-size: 1rem;
          color: #64748b;
          margin-bottom: 1rem;
        }
        .author-bio {
          font-size: 1rem;
          line-height: 1.7;
          color: #475569;
        }
                                /* Newsletter Card */
        .newsletter-form {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        .newsletter-form input[type="email"] {
          padding: 0.75rem 1rem;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 1rem;
          outline: none;
        }
        .newsletter-form input[type="email"]:focus {
          border-color: #dc2626;
          box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);
        }
        .newsletter-form button {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          padding: 0.75rem 1rem;
          border: none;
          border-radius: 8px;
          font-size: 1rem;
          font-weight: 700;
          cursor: pointer;
          transition: background 0.3s;  
        }
        .newsletter-form button:hover {
          background: linear-gradient(135deg, #b91c1c 0%, #15803d 100%);
        }
                                /* Useful Links */
        .useful-links ul {
          list-style: none;
          padding-left: 0;
        }
        .useful-links ul li {
          margin-bottom: 1rem;
        }
        .useful-links ul li a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          text-decoration: none;
          color: #475569;
          font-weight: 600;
          transition: color 0.3s;
        }
        .useful-links ul li a:hover {
          color: #dc2626;
        }
        .useful-links ul li a span {
          font-size: 1.2rem;
          color: #dc2626;
        }
                `}</style>
            </div>
        
        </>
           );
             };
export default DetailBlog14;

